import axios from "axios";

const pharmacyId = process.env.REACT_APP_PHARMACY_ID;

export const getAllOutlets = async (
  
  customerId,
  
) => {
  
  

  const promise = axios.post(
    `${process.env.REACT_APP_API}api/v1/GetOutlets`,
    {
      pharmacyId
    }
  );

  const dataPromise = promise.then((response) =>  response.data.response.outlets);

 
  return dataPromise;
};


